import { getOriginId } from '../../../utils/utils';
import { ItemKind } from '../../../constants/ItemKind';
export const toFolder = (data, parentId) => ({
  id: getOriginId(data.guid),
  name: data.title,
  mediaType: data.mediaType,
  kind: ItemKind.Folder,
  tags: data.systemTags || [],
  source: 'public',
  parentId: parentId ? getOriginId(parentId) : null,
  filesCount: null,
  createdAt: null
});